var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625H4.375C4.20924 10.625 4.05027 10.5592 3.93306 10.4419C3.81585 10.3247 3.75 10.1658 3.75 10C3.75 9.83424 3.81585 9.67527 3.93306 9.55806C4.05027 9.44085 4.20924 9.375 4.375 9.375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63389 10.0001L9.81764 15.1826C9.935 15.2999 10.0009 15.4591 10.0009 15.6251C10.0009 15.791 9.935 15.9502 9.81764 16.0676C9.70028 16.1849 9.54111 16.2508 9.37514 16.2508C9.20917 16.2508 9.05 16.1849 8.93264 16.0676L3.30764 10.4426C3.24944 10.3845 3.20326 10.3155 3.17175 10.2396C3.14024 10.1637 3.12402 10.0823 3.12402 10.0001C3.12402 9.91785 3.14024 9.83645 3.17175 9.76052C3.20326 9.68458 3.24944 9.61561 3.30764 9.55756L8.93264 3.93256C9.05 3.8152 9.20917 3.74927 9.37514 3.74927C9.54111 3.74927 9.70028 3.8152 9.81764 3.93256C9.935 4.04992 10.0009 4.20909 10.0009 4.37506C10.0009 4.54103 9.935 4.7002 9.81764 4.81756L4.63389 10.0001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.9615358cbb5dabe5eff3985650e133b2.svg";
export { ForwardRef as ReactComponent };